import { queryKeys } from "@l2a/shared";
import { Inbox } from "lucide-react";
import { defineFeature } from "../types";

/**
 * Inbox — Every reply, mention, approval and form submission in one queue.
 * Roadmap item 6
 * STATUS: registered stub. The feature team replaces ./page with the real screens.
 */
export default defineFeature({
  key: "inbox",
  title: "Inbox",
  // `/notifications` is served by the `account` feature (the real notification
  // inbox); this feature owns the unified reply / approval queue at `/inbox`.
  routes: [{ path: "inbox", lazy: () => import("./page") }],
  nav: [
    {
      label: "Inbox",
      to: "/inbox",
      icon: Inbox,
      group: "home",
      order: 20,
      badgeQueryKey: queryKeys.list("notification", { unread: true }),
      description: "Replies, mentions and approvals in one queue",
    },
  ],
});
